import { useStaticQuery, graphql } from 'gatsby';

/**
 * Hook to return the site URL.
 *
 * @returns {string} Site URL.
 */
const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `
  );

  return site.siteMetadata;
};

export default useSiteMetadata;
